module.exports = __webpack_public_path__ + "static/media/IMG_0388.08696690.JPG";